import { PRODUCT_BACKORDER, PRODUCT_PREORDER } from "theme/config/constants";
import getProductStockStatus, { getPackageStockStatus } from "core-web/utils/getProductStockStatus";

import { getFlag } from "core-web/utils/getFlag";

export const getProductAvailability = (product, locale) => {
    const {
        format: { flags },
        on_hand: onHand,
        included_products: includedProducts,
    } = product;

    let stockStatus;

    if (includedProducts?.length) {
        // package product
        [stockStatus] = getPackageStockStatus(includedProducts, locale);
    } else {
        // non-package
        stockStatus = getProductStockStatus(onHand, locale);
    }

    if (stockStatus.nextDelivery) {
        if (getFlag(PRODUCT_PREORDER, flags)) {
            return { preOrder: true, nextDelivery: stockStatus.nextDelivery };
        } else if (getFlag(PRODUCT_BACKORDER, flags)) {
            return { backOrder: true, nextDelivery: stockStatus.nextDelivery };
        }
    }
    //Wallmek always has products in stock
    return { inStock: true };
};

export const getAvailabilitySchemaUrl = (productAvailability) => {
    return productAvailability.inStock
        ? "http://schema.org/InStock"
        : productAvailability.preOrder
          ? "https://schema.org/PreOrder"
          : productAvailability.backOrder
            ? "https://schema.org/BackOrder"
            : "http://schema.org/OutOfStock";
};
